import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const userExternalDeliveryFileDownloadService = (key) => {
  return axiosInstance
    .get(`${ENDPOINTS.USER.DOWNLOAD_FILE.EXTERNAL_DELIVERY.DOWNLOAD}/${key}`)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
